import { IconButton, InputAdornment} from '@mui/material';
import { useState } from 'react'
import images from '../../../assets/images';
import { CustomTextField , maxLengthValidation, minLengthValidation, passwordRegexPattern } from '../../../helper';
import styles from '../../../features/ChangePassword/ResetPassword.module.css'

interface PasswordProps{
    errors: any,
    register: any
}
const PasswordTextField = CustomTextField();
  
const PasswordInputField = ({errors,register}:PasswordProps) => {
    const {passwordHideIcon,passwordUnHideIcon} = images;
  const [showPassword,setShowPassword] = useState<boolean>(false);
  const handleClickShowPassword =(e:React.MouseEvent<HTMLButtonElement>)=>{
    e.preventDefault();
    setShowPassword((show)=> !show);
  }
  return (
    <>
     <PasswordTextField 
          variant={"outlined"}
          name={"password"}
          type={showPassword ? "text" : "password"}
          {...register("password",{
            required: "Password is required!",
            minLength: minLengthValidation,
            maxLength: maxLengthValidation,
            pattern: {
              value: passwordRegexPattern,
              message: 'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
            }
          })}
          fullWidth
          placeholder={"Enter Password"}
          InputProps={{
              style: {
                borderRadius: 0,
                fontFamily: 'var(--body-b3-12-semibold-left)',
                fontSize: 'var(--body-b2-14-semibold-left-size)',
              },
              endAdornment: <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleClickShowPassword}
                                  edge="end"
                                  disableRipple
                                >
                                    {showPassword ? <img className="passwordUnHideIconStyle" src={passwordUnHideIcon} alt='unHideIcon'/> : <img src={passwordHideIcon} alt='hideIcon'/>}
                                </IconButton>
                            </InputAdornment>
            }}
            error={Boolean(errors?.password?.message)}
          />
         <span className={styles.errorMsgStyle}>{errors?.password?.message}</span>
    </>
  )
}

export default PasswordInputField
